import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 update_tenant_sms_credentials: { message: "idle" },
};

export const update_tenant_sms_credentials_Slice = createSlice({
 name: "update_tenant_sms_credentials",
 initialState,
 reducers: {
  success_update_tenant_sms_credentials: (state, action) => {
   state.update_tenant_sms_credentials = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_update_tenant_sms_credentials: (state, action) => {
   state.update_tenant_sms_credentials = { status: app_consts.FAIL, message: action.payload };
  },
  reset_update_tenant_sms_credentials: (state) => {
   state.update_tenant_sms_credentials = { status: app_consts.IDLE };
  },
  loading_update_tenant_sms_credentials: (state) => {
   state.update_tenant_sms_credentials = { status: app_consts.LOADING };
  },
 }
});

export const { success_update_tenant_sms_credentials, fail_update_tenant_sms_credentials, reset_update_tenant_sms_credentials, loading_update_tenant_sms_credentials } = update_tenant_sms_credentials_Slice.actions;

export default update_tenant_sms_credentials_Slice.reducer;